(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brands-carousel"] && !Shopify.designMode) return;
  try {
    
// Función inicializadora para el carrusel de marcas
function initBrandCarousel() {
  // Buscar todos los carruseles por clase
  const carousels = document.querySelectorAll('.brand-carousel');
  
  carousels.forEach(carousel => {
    // Elementos del carrusel
    const track = carousel.querySelector('.brand-carousel__track');
    const trackWrapper = carousel.querySelector('.brand-carousel__track-wrapper');
    const slides = carousel.querySelectorAll('.brand-carousel__slide');
    const prevArrow = carousel.querySelector('.brand-carousel__arrow--prev');
    const nextArrow = carousel.querySelector('.brand-carousel__arrow--next');
    const header = carousel.querySelector('.brand-carousel__header');
    const headerContainer = carousel.querySelector('.brand-carousel__header-container');
    
    // Configuración desde atributos data-*
    const autoplay = carousel.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(carousel.dataset.autoplaySpeed) || 5000;
    const showArrows = carousel.dataset.showArrows === 'true';
    const arrowStyle = carousel.dataset.arrowStyle || 'both';
    const desktopItems = parseInt(carousel.dataset.desktopItems) || 5;
    const mobileItems = parseInt(carousel.dataset.mobileItems) || 2;
    const scrollItems = parseInt(carousel.dataset.scrollItems) || 1;
    const disableScrollIfFit = carousel.dataset.disableScroll === 'true';
    const peekPercentage = parseInt(carousel.dataset.peekPercentage) || 15;
    
    // Variables de estado
    let autoplayInterval = null;
    const isMobile = () => window.innerWidth < 750;
    const isLargeScreen = () => window.innerWidth >= 1300;
    let slideWidth = 0;
    let gapWidth = 0;
    
    // Variables para arrastrar el carrusel
    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;
    let dragThreshold = 50; // Umbral para determinar si es un arrastre significativo
    let dragDirection = 0; // -1 para izquierda, 1 para derecha
    
    // Función para calcular dimensiones
    function calculateDimensions() {
      if (!slides.length) return;
      
      const firstSlide = slides[0];
      slideWidth = firstSlide.offsetWidth;
      gapWidth = parseInt(getComputedStyle(track).getPropertyValue('gap')) || 0;
    }
    
    // Función para alinear el encabezado
    function alignHeader() {
      setTimeout(() => {
        if (!slides.length || !headerContainer) return;
        
        if (isLargeScreen()) {
          const firstSlide = slides[0];
          if (!firstSlide) return;
          
          const firstSlideRect = firstSlide.getBoundingClientRect();
          const trackRect = trackWrapper.getBoundingClientRect();
          
          let leftOffset = firstSlideRect.left - trackRect.left;
          
          headerContainer.style.paddingLeft = `${leftOffset}px`;
          headerContainer.style.textAlign = 'left';
        } else {
          headerContainer.style.paddingLeft = '';
          headerContainer.style.textAlign = '';
        }
      }, 300);
    }
    
    // Función para actualizar estado del carrusel
    function updateCarouselState() {
      const visibleItems = isMobile() ? mobileItems : desktopItems;
      
      if (disableScrollIfFit && slides.length <= visibleItems) {
        if (prevArrow) {
          prevArrow.style.display = 'none';
        }
        if (nextArrow) {
          nextArrow.style.display = 'none';
        }
        
        pauseAutoplay();
      } else {
        if (showArrows) {
          if (prevArrow && (arrowStyle === 'both' || arrowStyle === 'left')) {
            prevArrow.style.display = '';
          }
          if (nextArrow && (arrowStyle === 'both' || arrowStyle === 'right')) {
            nextArrow.style.display = '';
          }
        }
        
        if (autoplay) {
          startAutoplay();
        }
      }
      
      checkArrowsVisibility();
    }
    
    // Función para verificar visibilidad de flechas
    function checkArrowsVisibility() {
      if (!track) return;
      
      if (prevArrow) {
        if (track.scrollLeft <= 0) {
          prevArrow.classList.add('disabled');
        } else {
          prevArrow.classList.remove('disabled');
        }
      }
      
      if (nextArrow) {
        if (Math.ceil(track.scrollLeft + track.offsetWidth) >= track.scrollWidth) {
          nextArrow.classList.add('disabled');
        } else {
          nextArrow.classList.remove('disabled');
        }
      }
    }
    
    // Función para desplazamiento hacia atrás
    function scrollPrev() {
      if (!track || !slides.length) return;
      
      // Recalcular dimensiones para asegurar valores actualizados
      calculateDimensions();
      
      // Calcular la cantidad de desplazamiento
      const itemWidth = slideWidth + gapWidth;
      const scrollAmount = itemWidth * scrollItems;
      
      // No desplazar si ya está al inicio
      if (track.scrollLeft <= 0) return;
      
      // Calcular nueva posición
      let nextPosition = track.scrollLeft - scrollAmount;
      if (nextPosition < 0) nextPosition = 0;
      
      // Realizar el scroll
      track.scrollTo({
        left: nextPosition,
        behavior: 'smooth'
      });
      
      // Actualizar visibilidad de flechas después del scroll
      setTimeout(() => {
        checkArrowsVisibility();
      }, 300);
    }
    
    // Función para desplazamiento hacia adelante
    function scrollNext() {
      if (!track || !slides.length) return;
      
      // Recalcular dimensiones para asegurar valores actualizados
      calculateDimensions();
      
      // Calcular la cantidad de desplazamiento
      const itemWidth = slideWidth + gapWidth;
      const scrollAmount = itemWidth * scrollItems;
      
      // Calcular el límite máximo de desplazamiento
      const maxScroll = track.scrollWidth - track.offsetWidth;
      
      // No desplazar si ya está al final
      if (Math.ceil(track.scrollLeft) >= maxScroll) return;
      
      // Calcular nueva posición
      let nextPosition = track.scrollLeft + scrollAmount;
      if (nextPosition > maxScroll) nextPosition = maxScroll;
      
      // Realizar el scroll
      track.scrollTo({
        left: nextPosition,
        behavior: 'smooth'
      });
      
      // Actualizar visibilidad de flechas después del scroll
      setTimeout(() => {
        checkArrowsVisibility();
      }, 300);
    }
    
    // Función para iniciar autoplay
    function startAutoplay() {
      if (autoplayInterval) return;
      
      autoplayInterval = setInterval(() => {
        // Si está al final, volver al inicio
        if (Math.ceil(track.scrollLeft + track.offsetWidth) >= track.scrollWidth) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          scrollNext();
        }
      }, autoplaySpeed);
    }
    
    // Función para pausar autoplay
    function pauseAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }
    
    // Funciones para arrastrar el carrusel
    function dragStart(e) {
      // No prevenir el comportamiento predeterminado para enlaces
      if (e.target.closest('a')) return;
      
      e.preventDefault();
      
      // Pausar autoplay mientras se arrastra
      pauseAutoplay();
      
      // Guardar la posición inicial y el estado del desplazamiento
      isDragging = true;
      startX = getPositionX(e);
      scrollLeft = track.scrollLeft;
      dragDirection = 0;
      
      // Cambiar el cursor y añadir clase de arrastre
      track.style.cursor = 'grabbing';
      track.classList.add('brand-carousel__track--dragging');
    }
    
    function drag(e) {
      if (!isDragging) return;
      
      // Calcular la distancia arrastrada
      const currentX = getPositionX(e);
      const moveX = startX - currentX;
      
      // Determinar la dirección del arrastre
      if (Math.abs(moveX) > 10) {
        dragDirection = moveX > 0 ? 1 : -1;
      }
    }
    
    function dragEnd(e) {
      if (!isDragging) return;
      
      isDragging = false;
      track.style.cursor = 'grab';
      track.classList.remove('brand-carousel__track--dragging');
      
      // Calcular la distancia arrastrada
      const currentX = getPositionX(e);
      const moveX = startX - currentX;
      
      // Si el arrastre fue significativo, desplazar en la dirección correspondiente
      if (Math.abs(moveX) > dragThreshold) {
        if (moveX > 0) {
          // Arrastrado hacia la izquierda, mover hacia adelante
          scrollNext();
        } else {
          // Arrastrado hacia la derecha, mover hacia atrás
          scrollPrev();
        }
      }
      
      // Si el autoplay estaba activo, reiniciarlo
      if (autoplay) {
        startAutoplay();
      }
    }
    
    // Obtener la posición X del evento (táctil o mouse)
    function getPositionX(e) {
      return e.type.includes('mouse') 
        ? e.clientX 
        : e.touches[0].clientX;
    }
    
    // Manejar eventos de cancelación
    function dragCancel() {
      if (!isDragging) return;
      
      isDragging = false;
      track.style.cursor = 'grab';
      track.classList.remove('brand-carousel__track--dragging');
      
      if (autoplay) {
        startAutoplay();
      }
    }
    
    // Inicialización
    calculateDimensions();
    
    // Añadir event listeners a las flechas
    if (prevArrow) {
      prevArrow.addEventListener('click', function(e) {
        e.preventDefault();
        scrollPrev();
      });
    }
    
    if (nextArrow) {
      nextArrow.addEventListener('click', function(e) {
        e.preventDefault();
        scrollNext();
      });
    }
    
    // Añadir event listeners para arrastrar
    if (track) {
      // Eventos de mouse
      track.addEventListener('mousedown', dragStart);
      track.addEventListener('mousemove', drag);
      track.addEventListener('mouseup', dragEnd);
      track.addEventListener('mouseleave', dragCancel);
      
      // Eventos táctiles
      track.addEventListener('touchstart', dragStart, { passive: false });
      track.addEventListener('touchmove', drag, { passive: true });
      track.addEventListener('touchend', dragEnd);
      track.addEventListener('touchcancel', dragCancel);
      
      // Prevenir el comportamiento predeterminado de arrastrar imágenes
      track.addEventListener('dragstart', function(e) {
        e.preventDefault();
      });
      
      // Establecer el cursor inicial
      track.style.cursor = 'grab';
    }
    
    // Actualizar estado inicial
    updateCarouselState();
    
    // Configurar autoplay
    if (autoplay) {
      startAutoplay();
      
      carousel.addEventListener('mouseenter', () => {
        pauseAutoplay();
      });
      
      carousel.addEventListener('mouseleave', () => {
        startAutoplay();
      });
    }
    
    // Alinear el título
    if (headerContainer && isLargeScreen()) {
      alignHeader();
    }
    
    // Manejar eventos de redimensionamiento
    const handleResize = () => {
      calculateDimensions();
      updateCarouselState();
      
      if (headerContainer) {
        alignHeader();
      }
    };
    
    window.addEventListener('resize', handleResize);
    
    // Evento scroll en el carrusel
    if (track) {
      track.addEventListener('scroll', () => {
        checkArrowsVisibility();
      });
    }
    
    // Asegurar que todo se alinee después de cargar
    window.addEventListener('load', () => {
      calculateDimensions();
      checkArrowsVisibility();
      if (headerContainer) {
        alignHeader();
      }
    });
    
    // Añadir clase de estilo para indicar que tiene funcionalidad de arrastre
    if (track) {
      track.classList.add('brand-carousel__track--draggable');
    }
  });
}

// Inicializar cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', initBrandCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navidad-compra-por-precio-imgbv2"] && !Shopify.designMode) return;
  try {
    

function initSlider() {
  var $sliderSelector = $('.slider-thebox');
  var $sliderContainer = $sliderSelector.closest('.slideshow-wrapper');

if (!$sliderSelector.length) {
  return false;	
}

  /* Slider settings */
  var settings = {
    accessibility: true,
    arrows: false,
    dots: false,
    fade: true,
    draggable: true,
    touchThreshold: 20,
    centerMode: true,
    centerPadding: '40px',
    slidesToShow: 1,
    mobileFirst: true,
    responsive: [{
      breakpoint: 767,
      settings: "unslick"
    }]
  }

  // data options
  settings.autoplay = $sliderSelector.data('autorotate');
  settings.autoplaySpeed = $sliderSelector.data('speed');

  var adaptHeight = $sliderSelector.data('adapt-height');
  var minAspectRatio = $sliderSelector.data('min-aspect-ratio');
  var sideArrows = $sliderSelector.data('side-arrows');

  if (adaptHeight) {
    $sliderSelector.height($(document).width() / minAspectRatio);
    $(window).resize($.debounce(50, function() {
      $sliderSelector.height($(document).width() / minAspectRatio);
    }));
  }

  var slider = $sliderSelector.slick(settings);

  var $prevArrow = $sliderContainer.find('.side-arrow.side-arrow-left')
  var $nextArrow = $sliderContainer.find('.side-arrow.side-arrow-right')

  if (sideArrows && $sliderSelector.hasClass('slick-initialized')) {
    if ($prevArrow && $prevArrow.length) {
      $prevArrow.on('click', function() {
        $sliderSelector.slick('slickPrev');
      });
    }
    if ($nextArrow && $nextArrow.length) {
      $nextArrow.on('click', function() {
        $sliderSelector.slick('slickNext');
      });
    }
  }

  /* Do this every time window gets resized */
  $(window).on('resize', function() {
    if ($(window).width() < 767) {
    /* We are below mobile breakpoint, initialize the slider
      if it is not already initialized */
    if (!slider.hasClass('slick-initialized')){
        return slider.slick(settings);
      }
    }
  })
}
                                
initSlider();



  } catch(e) { console.error(e); }
})();
})();
